import { FC } from 'react';
import { TextField, useTheme } from '@mui/material';
import { MdSearch } from 'react-icons/md';

const NodeFilter: FC<React.PropsWithChildren<NodeFilterProps>> = props => {
  const { value, onFilterChange } = props;
  const onChange = event => {
    onFilterChange(event.currentTarget.value);
  };
  const theme = useTheme();
  return (
    <TextField
      size='small'
      value={value}
      onChange={onChange}
      placeholder='Search'
      sx={{
        minWidth: 200,
        mx: 1,
        backgroundColor: theme.palette.background.default,
      }}
      InputProps={{
        endAdornment: <MdSearch />,
      }}
    />
  );
};

export interface NodeFilterProps {
  value: string;
  onFilterChange: (value: string) => void;
}

export default NodeFilter;
